// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ShoppingCartLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M8.56 18.44a1.5 1.5 0 11-2.12 2.12 1.5 1.5 0 012.12-2.12zm10 0a1.5 1.5 0 11-2.12 2.12 1.5 1.5 0 012.12-2.12zM5 3a1 1 0 011 .74L6.58 6h12.8a2 2 0 011.7 1 2 2 0 01.09 1.89l-3.28 6.56A1 1 0 0117 16H8a1 1 0 01-1-.74L4.24 5H3a1 1 0 110-2zm14.38 5H7.13l1.63 6h7.62l3-6z"
                fill="currentColor"
                fillRule="evenodd"
                focusable="false"
            />
        </svg>
    );
};

export const ShoppingCartLineOffset: IconOffset = {
    vertical: 12,
    horizontal: 8,
};

export default React.memo(ShoppingCartLine);
